import ProductionPlantTable from './ProductionPlantTable';

export default ProductionPlantTable;
